import * as React from 'react';
import * as style from './style.css';
import { Image, UIHeading2, UIHeading3, UIHeading4, UIText1, UIText3 } from '@cian/ui-kit';
import { IconProduct3DTour16 } from '@cian/ui-kit-design-tokens/icons';
import { OffersContext } from '../../../../../../shared/context';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ModalHeader = _ref => {
  let {
    contactsButton,
    contact
  } = _ref;
  const {
    layout
  } = React.useContext(OffersContext);
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['image'],
      children: [/*#__PURE__*/_jsx(Image, {
        src: layout.imageUrl,
        alt: "\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0430",
        width: 240,
        height: 188,
        objectFit: "contain"
      }), layout.hasTour && /*#__PURE__*/_jsx("div", {
        className: style['tour'],
        children: /*#__PURE__*/_jsx(IconProduct3DTour16, {
          color: "icon-main-default"
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: style['info-block'],
      children: [/*#__PURE__*/_jsxs("div", {
        className: style['layout'],
        children: [/*#__PURE__*/_jsxs("div", {
          className: style['layout-params'],
          children: [/*#__PURE__*/_jsx(UIText1, {
            children: layout.title
          }), /*#__PURE__*/_jsx(UIHeading3, {
            children: layout.square
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: style['layout-price'],
          children: [/*#__PURE__*/_jsx(UIHeading2, {
            textAlign: "right",
            children: layout.price
          }), /*#__PURE__*/_jsx(UIText1, {
            color: "current_color",
            textAlign: "right",
            children: layout.pricePerMeter
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: style['contacts'],
        children: [/*#__PURE__*/_jsx("div", {
          className: style['contacts-contact'],
          children: contact && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("img", {
              className: style['contact-image'],
              src: contact.imageUrl,
              alt: contact.name
            }), /*#__PURE__*/_jsxs("div", {
              className: style['contacts-contact-title'],
              children: [/*#__PURE__*/_jsx(UIText3, {
                color: "current_color",
                children: contact.type
              }), /*#__PURE__*/_jsx(UIHeading4, {
                children: contact.name
              })]
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: style['contacts-control'],
          "data-testid": "OffersModalContactButton",
          children: contactsButton
        })]
      })]
    })]
  });
};